(function ($) {
  $(".js-bespoke-selection").each(function () {
    var slide = $(this).find(".js-bespoke-selection__slider");

    $(slide).slick({
      accessibility: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      speed: 1000,
      prevArrow: '.js-bespoke-selection__prev',
      nextArrow: '.js-bespoke-selection__next',
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //   },
        // },
      ],
    });

    var slideIndex = 0;
    $(slide).on('afterChange', function(slick, currentSlide){
      $(slide).removeClass("current-slide-"+slideIndex);
      $(slide).addClass("current-slide-"+currentSlide.currentSlide);
      slideIndex = currentSlide.currentSlide;
    });
  });
})(jQuery);
